import React from 'react';
import { armsErrorSend } from '@/utils/libs/armsErrorSend';
import { feishuRobotSend } from '@/utils/feishuRobot';

const notSendFeishu = ['G_Header Nav', 'OrderSummaryAction Policy'];

/**
 * 组件级错误捕获，捕获后将直接不显示组件或者传入兜底样式
 * @param {string} name 组件名，方法filename，方便跟踪
 * @param {Object} data 相关数据，对象类型
 * @param {Array} at 通知相关人员
 * @param {function} catchErrorCallback 捕获错误后的兜底方法。
 * @param errorCatchDisplay 兜底展示组件
 */
export default class ComponentsErrorBoundary extends React.Component {
  state = {};

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    try {
      !notSendFeishu.some((d) => this.props.name?.includes?.(d)) &&
        feishuRobotSend({
          err: error,
          text: [
            `【ComponentsErrorBoundary Catch ${this.props.name}】`,
            `【捕获 errorInfo】：${JSON.stringify(errorInfo ?? '')}`,
            `【上报信息】: ${JSON.stringify(this.props.data ?? '')}`,
          ],
          at: ['dxy', ...(this.props?.at ?? [])],
        });
      armsErrorSend(error, {
        filename: `ComponentsErrorBoundary Catch ${this.props.name}`,
        data: { errorInfo, data: this.props.data },
      });
      this.handleToggleGlobalScroll();
      this.props.catchErrorCallback?.();
    } catch (e) {
      armsErrorSend(e, {
        filename: `ComponentsErrorBoundary Error callback ${this.props.name}`,
      });
    }
  }

  // 弹窗等组件报错引起页面崩溃的情况处理页面滑动
  handleToggleGlobalScroll = () => {
    setTimeout(() => {
      if (document?.body?.dataset?.hidecustomerservice === 'true' || document?.body?.style.overflowY === 'hidden') {
        document.body.style.overflowY = `scroll`;
        document.body.setAttribute('data-HideCustomerService', false);
      }
    }, 0);
  };

  render() {
    if (this.state?.hasError) {
      return this.props.errorCatchDisplay ?? <div />;
    }

    return this.props.children ?? <div />;
  }
}
